export default {
  'MultipleTermSearch.Wrapper.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ value })
  },
  'MultipleTermSearch.Wrapper.SearchInput(Keydown)': ({ value, key, searchTerms }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      if (!searchTerms.includes(value) && value) {
        outlet({ searchTerms: [...searchTerms, value] })
      }
      internalStateSetter({ value: '' })
    }
  },
  'MultipleTermSearch.Wrapper.SelectedButton': ({ text, searchTerms }, outlet) => {
    outlet({ searchTerms: searchTerms.filter(t => t !== text) })
  }
}